/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function() {
  // Função para alterar o texto
  function updateReviewScore() {
    const reviewScoreElement = document.querySelector(
      ".Vtl-ReviewsBadge__Score.Vtl-ReviewsBadge__Score--Vertical.Vtl-ReviewsBadge__Score--Custom.borderless.transparent"
    );
    if (reviewScoreElement) {
      reviewScoreElement.textContent = "4.8";
      return true; // Elemento encontrado e atualizado
    }
    return false; // Ainda não encontrado
  }

  // Primeira tentativa imediata
  if (updateReviewScore()) return;

  // Se não encontrou, observa mudanças no DOM
  const observer = new MutationObserver(() => {
    if (updateReviewScore()) {
      observer.disconnect(); // Para de observar quando atualizar
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  setTimeout(function() { observer.disconnect(); }, 10000);
});
